const BuyLinesColumns = [
    { headerName: "Charge Type", field: "chargeType" },
    { headerName: "Brand", field: "brand" },
    { headerName: "Charge Period Date", field: "chargePeriod" },
    { headerName: "Vendor No.", field: "vendorNo" },
    { headerName: "Associate Vendor No.", field: "assVendorNo" },
    { headerName: "Customer No.", field: "custNo" },
    { headerName: "RA Number", field: "raNumber" },
    { headerName: "License Rental Agreement No.", field: "licRentAgreeNo" },
    { headerName: "Charge Code1", field: "cc1" },
    { headerName: "NetVoucher Value", field: "netVouchValue" },
    { headerName: "DI", field: "diValue" },
    { headerName: "Total Buy Rentals", field: "totalBuyRent" },
    { headerName: "Charge Code2", field: "cc2" },
    { headerName: "Voucher Fee", field: "voucherFee" },
    { headerName: "DI Fee", field: "diFee" },
    { headerName: "Total Fee", field: "totalFee" },
    { headerName: "Charge Code3", field: "cc3" },
    { headerName: "Charge Code4", field: "cc4" },
    { headerName: "Credit Club Value Purchase", field: "crClValuePurch" },
    { headerName: "TM Split", field: "tmSplit" },
    { headerName: "CWD Split", field: "cwdSplit" },
    { headerName: "TP Split", field: "tpSplit" },
    { headerName: "PAI Split", field: "paiSplit" },
    { headerName: "One Way Fee", field: "oneWayFee" },
    { headerName: "Fuel", field: "fuel" },
    { headerName: "Cash Refund", field: "cashRefund" },
    { headerName: "Other Deductions", field: "otherDed" },
    { headerName: "Total Deductions", field: "totalDed" },
    { headerName: "Charge Code5", field: "cc5" },
    { headerName: "Adjustment Value", field: "adjValue" },
    { headerName: "Adjustment Reason Code", field: "adjReason" },
    { headerName: "Nav Reason Code", field: "navReason" },
    { headerName: "Customer Billing Currency", field: "custBillCurr" },
    { headerName: "Checkout Date", field: "checkoutDate" },
    { headerName: "Location Code", field: "locCode" },
    { headerName: "Checkout Location", field: "coLoc" },
    { headerName: "Checkin Location", field: "ciLoc" },
    { headerName: "Customer Account No.", field: "custAccNo" },
    { headerName: "Customer Account Name", field: "custAccName" },
    { headerName: "IATA", field: "iata" },
    { headerName: "Agency Name", field: "agencyName" },
    { headerName: "Voucher Number", field: "voucherNo" },
    { headerName: "Voucher Value", field: "voucherValue" },
    { headerName: "Voucher Commission", field: "voucherComm" },
    { headerName: "Commission Tax", field: "commonTax" },
    { headerName: "Sub Total", field: "subTotal" },
    { headerName: "Fee", field: "fee" },
    { headerName: "Net BuySell", field: "netBuySell" },
    { headerName: "Country Code Bought From", field: "countryCode" },
    { headerName: "Commissionable Revenue", field: "commRev" },
    { headerName: "Commission Percent", field: "commPerc" },
    { headerName: "Referral Commission", field: "refComm" },
    { headerName: "Referral Commission Tax", field: "refCommTax" },
    { headerName: "Total Referral Commission & Tax", field: "totRefCommTax" },
    { headerName: "DI Value Sold Purchased", field: "diValueSoldPurch" },
    { headerName: "DI BuySell Fee", field: "diBuySellFee" },
    { headerName: "Secondary CreditId", field: "secCreditID" },
    { headerName: "Secondary Currency Code", field: "secCurrCode" },
    { headerName: "FX Rate", field: "fxRate" },
    { headerName: "CL Indicator", field: "clInd" },
    { headerName: "Station Indicator", field: "stationInd" },
    { headerName: "Vehicle Registration No.", field: "vehicleRegNo" }
];

export default BuyLinesColumns;